var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#F8F9FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1202 19.5003H24.0005C21.5153 19.4979 19.4986 21.5105 19.4961 23.9957C19.4954 24.7676 19.6932 25.5268 20.0706 26.2001L14.5107 16.6604C18.5603 11.4192 26.092 10.4532 31.3332 14.5028C33.0163 15.8033 34.3234 17.5281 35.1202 19.5003Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9996 24.0004C35.9941 30.6253 30.6249 35.9945 24 36.0001C23.4982 36.0019 22.997 35.9685 22.5 35.9001L27.8999 26.2503C29.1375 24.0958 28.3997 21.3461 26.2499 20.1005C25.5692 19.7064 24.7964 19.4994 24.0099 19.5005H35.1196C35.7036 20.9287 36.0026 22.4574 35.9996 24.0004Z",
    fill: "#FFC107"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9005 26.2499L22.5007 35.8997H22.4907C15.9195 35.0694 11.2656 29.0694 12.0959 22.4983C12.3646 20.3714 13.1985 18.3554 14.5109 16.6602L20.0707 26.1999L20.1007 26.2499C21.3406 28.4038 24.0917 29.1447 26.2455 27.9049C26.9336 27.5088 27.5045 26.9379 27.9005 26.2499Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9001 26.2503C26.6603 28.4042 23.9092 29.1451 21.7553 27.9053C21.0674 27.5093 20.4964 26.9383 20.1004 26.2503L20.0704 26.2003C18.8553 24.0324 19.6279 21.2899 21.7959 20.0749C22.4693 19.6975 23.2284 19.4997 24.0002 19.5005H24.0102C24.7967 19.4994 25.5695 19.7064 26.2502 20.1005C28.4001 21.3462 29.1378 24.0958 27.9001 26.2503Z",
    fill: "#F44336"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9001 26.2503C26.6603 28.4042 23.9092 29.1451 21.7553 27.9053C21.0674 27.5093 20.4964 26.9383 20.1004 26.2503L20.0704 26.2003C18.8553 24.0324 19.6279 21.2899 21.7959 20.0749C22.4693 19.6975 23.2284 19.4997 24.0002 19.5005H24.0102C24.7967 19.4994 25.5695 19.7064 26.2502 20.1005C28.4001 21.3462 29.1378 24.0958 27.9001 26.2503Z",
    fill: "#2196F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9837 28.9997C23.1119 28.9996 22.2555 28.7699 21.5007 28.3337C20.7396 27.8935 20.1075 27.2611 19.6678 26.4998C18.2871 24.1084 19.1064 21.0505 21.4978 19.6699C22.2587 19.2306 23.122 18.9995 24.0007 19C26.762 18.9978 29.0023 21.2347 29.0044 23.996C29.0051 24.875 28.774 25.7386 28.3345 26.4998C27.4334 28.049 25.7758 29.0014 23.9837 28.9997ZM24.0096 20C22.5747 19.9923 21.2462 20.756 20.5307 21.9999C19.4262 23.9152 20.0834 26.3633 21.9986 27.4678C23.9139 28.5723 26.362 27.9151 27.4665 25.9998C28.571 24.0867 27.9156 21.6404 26.0025 20.5359C25.3968 20.1862 24.71 20.0014 24.0106 20H24.0096V20Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.f848b1193efb83026000d5feed20344f.svg";
export { ForwardRef as ReactComponent };